import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";


const BusinessPolicyUpdates = Loadable(
  lazy(() =>
    import("./BusinessPolicyUpdates").then(({ BusinessPolicyUpdates }) => ({
      default: BusinessPolicyUpdates,
    }))
  )
);

export const BusinessPolicyUpdatesRoutes = [
  {
    path: `/business-policy/:customerId/updates/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <BusinessPolicyUpdates />
      </AuthorizedRoute>
    ),
  },
]